import React from "react"
import { H2, Stack, FlexContainer, Divider, Body, Button } from "@carrotfertility/carotene"
import { IlloCalendar } from "components/views/atoms/Illustrations"
import Locations from "components/views/home/navigation"
import { useHistory } from "react-router-dom"
import { FormattedMessage } from "react-intl"

type EnrollmentExpiredReminderProps = {
  onExit: () => void
}

const EnrollmentExpiredReminder = (props: EnrollmentExpiredReminderProps): JSX.Element => {
  const history = useHistory()

  const onClickUpdate = (): void => history.push(Locations.Home.EnrollmentFlowActive)

  return (
    <Stack paddingTopBottom="medium" paddingLeftRight="huge">
      <IlloCalendar />
      <FlexContainer direction="column">
        <H2>
          <FormattedMessage defaultMessage="Your Insurance Info Has Expired" />
        </H2>
        <Body size="small">
          <FormattedMessage defaultMessage="Update now to access your Carrot funds" />
        </Body>
      </FlexContainer>
      <Divider />
      <Stack alignItems="center" spacing="small" direction={["column", null, "row"]}>
        <Button variant="primary" onClick={onClickUpdate}>
          <FormattedMessage defaultMessage="Update now" />
        </Button>
        <Button variant="secondary" onClick={props.onExit}>
          <FormattedMessage defaultMessage="I'll do this later" />
        </Button>
      </Stack>
    </Stack>
  )
}

export default EnrollmentExpiredReminder
